export class Tel {
  id: string = '';
  numero: string = '';
  libelle: any = '';

  constructor() {}
}
